@if (vm$ | async; as vm) {
  <div
    class="min-h-screen flex items-center justify-center bg-surface-v2 relative overflow-hidden">
    <div
      class="absolute inset-0 bg-radial-[at_50%_100%] from-[#1A2366] from-0% to-70% to-transparent top-[85%] w-3/4 left-1/2 -translate-x-1/2 lg:block hidden"></div>

    <div
      class="absolute inset-0 bg-gradient-to-t from-[#1A2366] from-0% to-70% to-transparent top-[85%] w-full left-1/2 -translate-x-1/2 lg:hidden"></div>

    <div class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative">
      <div class="text-center flex items-center flex-col gap-4">
        <img
          src="./assets/images/logos/incidite-head-white.svg"
          alt="Incidite Logo"
          class="w-10 h-10" />
        <div class="flex flex-col gap-3">
          <h1 class="text-3xl font-medium">
            {{ 'pages.joinOrganization.header' | transloco: { organizationName: invitation?.organization?.name } }}
          </h1>
          <p class="text-subtle">{{ 'pages.joinOrganization.subHeader' | transloco }}</p>
        </div>
      </div>
      <v-card padding="lg" variant="glass-v2">
        <div class="vops-kratos-login-form" slot="body">
          @if (vm.user) {
            <v-user-card [user]="vm.user"></v-user-card>
          }
          @if (vm.isAlreadyMember) {
            <div class="mt-4">
              <v-message severity="info">
                {{ 'pages.joinOrganization.alreadyMember' | transloco }}
              </v-message>
            </div>
            <div class="mt-4 flex space-between gap-2">
              <div>
                <v-button-v2
                  [fullWidth]="true"
                  icon="pi pi-user-plus"
                  type="submit"
                  (press)="logout()">
                  {{ 'pages.joinOrganization.createNewAccountBtn' | transloco }}
                </v-button-v2>
              </div>
              <div class="flex-1">
                <v-button-v2
                  [fullWidth]="true"
                  icon="pi pi-home"
                  type="submit"
                  (press)="goToDashboard()">
                  {{ 'pages.joinOrganization.goToDashboardBtn' | transloco }}
                </v-button-v2>
              </div>
            </div>
          } @else {
            <form [formGroup]="joinOrgForm" (ngSubmit)="onFormSubmit()">
              @if (joinOrganizationError) {
                <p-message
                  severity="error"
                  styleClass="w-full mt-4"
                  [text]="joinOrganizationError"></p-message>
              }
              <div class="mt-4 justify-center w-full">
                <v-button-v2
                  [fullWidth]="true"
                  icon="pi pi-sign-in"
                  type="submit"
                  [loading]="this.isJoining"
                  [disabled]="!joinOrgForm.valid">
                  {{ 'pages.joinOrganization.joinBtn' | transloco }}
                </v-button-v2>
              </div>
            </form>
          }
        </div>
      </v-card>
    </div>
  </div>
}
